export const ENDPOINT_BASE = `${import.meta.env.VITE_MOLY_API}/api/v1.0`
